import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import { useContext, useState } from "react";
import emailjs from "emailjs-com";
import check from "../../assets/img/checkEnviado.png";
import { useParams } from "react-router-dom";
import loadingConsulta from "../../assets/img/preloader.gif";
import banderaArgentina from "../../assets/img/banderaArgentina.png";
import { VehiculosContext } from "../../context/VehiculosContext";
import ModalWarning from "../ModalWarning/ModalWarning";
import { sendPostRequest } from "../../config/desol";

const Formulario = ({
  vMarca,
  vModelo,
  filtrados,
  autoSeleccionado,
  tipo,
  setFormularioConInformacion,
  handleClose,
  handleShow,
  handleCloseAll,
  handleShowWarning,
  showWarning,
  handleCloseWarning,
}) => {
  let { id } = useParams();
  if (id === undefined) {
    id = "No seleccionado";
  }

  const { marcaLanding, modeloLanding } = useContext(VehiculosContext);

  const vehiculoSeleccionado = vModelo ? vModelo : "No Seleccionado";

  // leeo en sessionStorage los utm_source y utm_medium
  const utm_source = sessionStorage.getItem("utm_source") || "sin_utm_source";
  const utm_medium = sessionStorage.getItem("utm_medium") || "sin_utm_medium";
  // fin leeo en sessionStorage los utm_source y utm_medium

  const [validated, setValidated] = useState(false);
  const [tipoTemplate, setTipoTemplate] = useState("landing_unica_fiat_conv");
  const [desolChannel, setDesolChannel] = useState("C12_FIAT_JEEP_PEUGEOT_LANDINGS");
  const [status, setStatus] = useState(null);
  const [toSend, setToSend] = useState({
    name: "",
    email: "",
    phone: "",
    comments: "",
    medio: "Llamada",
    horario: "",
    vehicle: `${vMarca ? vMarca : ""} ${vehiculoSeleccionado}`,
    origen: `${utm_source ? utm_source : ""}  ${utm_medium ? utm_medium : ""}`,
    tipo: `${marcaLanding}_${modeloLanding}`,
  });

  const handleChange = (e) => {
    setToSend({ ...toSend, [e.target.name]: e.target.value });
    if (toSend.name !== "" || toSend.email !== "" || toSend.phone !== "") {
      setFormularioConInformacion(true);
    } else {
      setFormularioConInformacion(true);
    }

    if (tipo === "plan") {
      setTipoTemplate("landing_unica_fiat_plan");
    } else {
      setTipoTemplate("landing_unica_fiat_conv");
    }
  };

  // const onSubmit = (e) => {
  //   const form = e.currentTarget;
  //   if (form.checkValidity() === false) {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     // console.log("no valido");
  //   }
  //   setValidated(true);
  //   if (form.checkValidity() === true) {
  //     e.preventDefault();
  //     setStatus("cargando");
  //     emailjs
  //       .send("landingMontironi", tipoTemplate, toSend, "user_EIC1ELQk7I3NPaFMEDa64")
  //       .then((response) => {
  //         setStatus("ok");

  //         setTimeout(() => {
  //           setStatus(null);
  //           setValidated(false);
  //           setToSend({
  //             ...toSend,
  //             name: "",
  //             email: "",
  //             phone: "",
  //             comments: "",
  //             medio: "",
  //             horario: "",
  //             vehicle: "",
  //             origen: "",
  //             tipo: "",
  //           });
  //           window.location.href = "https://marketing.montironi.com/pulse/";
  //         }, 5000);

  //       })
  //       .catch((err) => {
  //         setStatus("error");
  //         setTimeout(() => {
  //           setStatus(null);
  //         }, 60000);
  //       });
  //   }
  // };

  const onSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior at the start

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();

      return;
    }

    setStatus("cargando");
    setValidated(true);

    const data = {
      Apellido: toSend.name,
      Email: toSend.email,
      Telefono: toSend.phone,
      Canal: tipo === "plan" ? "Plan de ahorro" : "Venta directa",
      Motivo: toSend.comments,
      OrigenLead: `${process.env.REACT_APP_LANDING} - ${utm_source}`,
      CommercialCampaign: utm_medium,
      Campaign: desolChannel,
      Modelo_Pedido: toSend.vehicle,
    };

    // EMAIL JS (ONLY FOR BACKUP)
    emailjs.send("landingMontironi", tipoTemplate, toSend, "user_EIC1ELQk7I3NPaFMEDa64");

    // API DESOL
    sendPostRequest(process.env.REACT_APP_DESOL_URL, data)
      .then((response) => {
        setStatus("ok");
        setTimeout(() => {
          setValidated(false);
          setToSend({
            ...toSend,
            name: "",
            email: "",
            phone: "",
            comments: "",
            medio: "",
            horario: "",
            vehicle: "",
            origen: "",
          });
          window.location.href = "https://oficial.montironi.com/toro/";
        }, 10000);
      })
      .catch((error) => {
        setStatus("error");
        setTimeout(() => {
          setStatus(null);
        }, 10000);
      });
  };

  return (
    <>
      {status === null && (
        <>
          <p className="titulo-formulario">Brindanos tus datos para poder comunicarnos con vos</p>
          <Form onSubmit={onSubmit} noValidate validated={validated}>
            <Row>
              <Col md={6} className="espacio-inpust-mobile">
                <label className="label-formulario-new">Nombre y apellido*</label>
                <Form.Control
                  id="name"
                  name="name"
                  type="text"
                  className="input-new-formulario"
                  placeholder="Nombre completo"
                  value={toSend.name}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label className="label-formulario-new">Nro de Celular*</label>
                <div className="contenedor-form-nrocelular">
                  <div className="contenedor-form-nrocelular-bandera input-new-formulario">
                    <img src={banderaArgentina} alt="I" />
                    <span>+549</span>
                  </div>
                  <Form.Control
                    id="phone"
                    name="phone"
                    type="number"
                    className="input-new-formulario"
                    placeholder="351 5898989"
                    value={toSend.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
                <p className="label-formulario-new-phone">Ingresá tu número sin 0 y sin 15.</p>
              </Col>
            </Row>
            <Row className="row-new-formulario">
              <Col md={6} className="espacio-inpust-mobile">
                <label className="label-formulario-new">E-mail*</label>
                <Form.Control
                  id="email"
                  name="email"
                  type="email"
                  className="input-new-formulario"
                  placeholder="ejemplo@gmail.com.ar"
                  value={toSend.email}
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col md={6}>
                <label className="label-formulario-new-select">Seleccione la opción por la cual consulta:</label>
                <Form.Select
                  id="vehicle"
                  name="vehicle"
                  className="formaContacto input-new-formulario"
                  onChange={handleChange}
                  required
                >
                  <option selected={true} className="text-uppercase">
                    Seleccione un vehículo
                  </option>
                  {filtrados.map((item) => {
                    return (
                      <option
                        value={item.id.toUpperCase()}
                        id={item.id.toUpperCase()}
                        name={item.id.toUpperCase()}
                        key={item.id.toUpperCase()}
                        selected={vehiculoSeleccionado.toUpperCase() === item.id.toUpperCase() ? true : false}
                      >
                        {item.id.toUpperCase()}
                      </option>
                    );
                  })}
                </Form.Select>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <label className="label-formulario-new">Dejanos tu consulta</label>
                <textarea
                  className="form-control input-new-formulario"
                  placeholder="Hola, quiero información sobre.."
                  name="comments"
                  id="comments"
                  rows="2"
                  onChange={handleChange}
                  value={toSend.comments}
                >
                  {toSend.comments}
                </textarea>
              </Col>
            </Row>

            <Row>
              <Col md={12} className="pb-3">
                <Button type="submit" className="btn-blue w-100 btn-enviar-formulario">
                  Enviar
                </Button>
              </Col>
            </Row>
          </Form>
        </>
      )}

      {status === "cargando" && (
        <div className="msgHeader text-center pt-5 pb-5" id="enviando-mensaje">
          <img src={loadingConsulta} alt="Cargando..." className="pb-3" width={250} />
          <p className="texto-loading-consulta">Estamos enviando tu consulta...</p>
        </div>
      )}

      {status === "ok" && (
        <div className="msgHeader text-center pt-5 pb-5" id="mensaje-enviado">
          <div>
            <img src={check} alt="Enviado" className="img-fluid" style={{ marginBottom: "20px", maxWidth: "60px" }} />
            <p className="titulo-formulario-enviado">¡Listo! ya enviamos tu solicitud.</p>
            <p className="subtitulo-formulario-enviado">Un asesor se contactará con vos a la brevedad. </p>
            <p className="parrafo-formulario-enviado">Ya podes cerrar ésta pestaña.</p>
          </div>
        </div>
      )}

      {status === "error" && (
        <div className="msgHeader pt-5 pb-5" id="mensaje-error">
          <div>
            <p
              style={{
                color: "red",
                fontWeight: "bold",
                fontSize: "22px",
                marginBottom: "0",
                textAlign: "center",
              }}
            >
              Se ha producido un error
            </p>
            <p style={{ textAlign: "center" }}>Vuelva a intentarlo mas tarde</p>
          </div>
        </div>
      )}
    </>
  );
};

export default Formulario;
